export const relativeRuler = (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 14V2.44444L18.3333 1H25.6667L27.5 2.44444V25.5556L25.6667 27H18.5H16.5H2.91667L1.5 25.625V17.375L2.91667 16H14.5H16.5V14ZM18.5 6V3.41486L19.0266 3H24.9734L25.5 3.41486V24.5851L24.9734 25H18.5H16.5H3.72766L3.5 24.779V18.221L3.72766 18H6.5V21H7.5V18H10.5V21H11.5V18H14.5V21H15.5V18H16.5H18.5V16V15H21.5V14H18.5V11H21.5V10H18.5V7H21.5V6H18.5ZM22.5 21C21.9477 21 21.5 21.4477 21.5 22C21.5 22.5523 21.9477 23 22.5 23C23.0523 23 23.5 22.5523 23.5 22C23.5 21.4477 23.0523 21 22.5 21Z"
      fill="currentColor"
      fillOpacity="0.9"
    />
  </svg>
);
